import { Box } from "@mui/material";

export function DisputeStatusChip({ status, config }) {
  const style = config[status] ?? { label: status ?? "N/A", bg: "#f3f4f6", color: "#374151" };

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        px: 2,
        py: 0.5,
        borderRadius: "999px",
        backgroundColor: style.bg,
        color: style.color,
        fontSize: "0.8rem",
        fontWeight: 500,
        whiteSpace: "nowrap",
      }}
    >
      {style.label}
    </Box>
  );
}
